export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9178.4f5e02c4.jpg";